import React, { useState } from 'react';
import { FiLayers, FiHome, FiSettings } from 'react-icons/fi';
import FloorManagement from './FloorManagement';
import RoomManagementContent from './RoomManagementContent';
import RoomSettings from './RoomSettings';

const RoomManagement = () => {
  const [activeTab, setActiveTab] = useState('floors');

  const tabs = [
    { id: 'floors', label: 'Floor', fullLabel: 'Floor Management', icon: FiLayers },
    { id: 'rooms', label: 'Rooms', fullLabel: 'Room Management', icon: FiHome },
    { id: 'settings', label: 'Settings', fullLabel: 'Settings', icon: FiSettings }
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'floors':
        return <FloorManagement />;
      case 'rooms':
        return <RoomManagementContent />;
      case 'settings':
        return <RoomSettings />;
      default:
        return <FloorManagement />;
    }
  };

  return (
    <div className="p-3 sm:p-4 md:p-6">

      {/* HEADER */}
      <div className="mb-4 sm:mb-6">
        <h1 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800 flex items-center">
          <FiLayers className="mr-2 w-5 h-5 sm:w-6 sm:h-6" />
          Room Management
        </h1>
        <p className="text-gray-600 mt-1 text-xs sm:text-sm">
          Manage floors and rooms
        </p>
      </div>

      {/* TAB NAVIGATION */}
      <div className="border-b border-gray-200 mb-4 sm:mb-6">

        {/* Scrollable on mobile */}
        <nav className="-mb-px flex gap-4 sm:gap-6 overflow-x-auto no-scrollbar">

          {tabs.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id;

            return (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center gap-1.5 sm:gap-2 py-2 px-2 sm:px-3 border-b-2 font-medium text-xs sm:text-sm whitespace-nowrap transition-all duration-200
                  ${isActive
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
              >
                <Icon className="w-4 h-4 sm:w-5 sm:h-5" />

                {/* Mobile short text */}
                <span className="sm:hidden">{tab.label}</span>

                {/* Desktop full text */}
                <span className="hidden sm:inline">{tab.fullLabel}</span>
              </button>
            );
          })}

        </nav>
      </div>

      {/* TAB CONTENT */}
      <div className="bg-white rounded-xl shadow-sm p-3 sm:p-4 md:p-5">
        {renderContent()}
      </div>

    </div>
  );
};

export default RoomManagement;